import "./Suggestions.scss";
import { escapeForRegExp } from "../TagUtils";
import React from "react";
import Highlighter from "react-highlight-words";

export interface SuggestionItem {
  id?: string | number;
  name?: string;
  prefix?: string;
  suffix?: string;
  disabled?: boolean;
  disableMarkIt?: boolean;
  suggestionLabel?: string;
  tooltip?: string;
  [key: string]: unknown;
}

export interface SuggestionsProps {
  query?: string;
  suggestions: SuggestionItem[];
  listboxId: string;
  selectedIndex: number;
  addTag: (item: SuggestionItem) => void;
  expandable: boolean;
}

const markIt = (
  input: string | undefined,
  query: string
): { __html: string } => {
  const regex = RegExp(escapeForRegExp(query), "gi");

  return {
    __html: (input ?? "").replace(regex, "<mark>$&</mark>"),
  };
};

const Suggestions: React.FC<SuggestionsProps> = ({
  query = "",
  suggestions,
  listboxId,
  selectedIndex,
  addTag,
  expandable,
}) => {
  const handleMouseDown = (
    item: SuggestionItem,
    e: React.MouseEvent<HTMLLIElement>
  ) => {
    // focus is shifted on mouse down but calling preventDefault prevents this
    e.preventDefault();
    addTag(item);
  };

  if (!expandable || !suggestions.length) {
    return null;
  }

  return (
    <div className="tags-select__suggestions">
      <ul role="listbox" id={listboxId}>
        {suggestions.map((item, i) => {
          const key = `${listboxId}-${i}`;
          const classNamesArray = [];

          if (selectedIndex === i) {
            classNamesArray.push("is-active");
          }

          if (item.disabled) {
            classNamesArray.push("is-disabled");
          }

          return (
            <li
              id={key}
              key={key}
              role="option"
              className={`suggestions-wrap ${classNamesArray.join(" ")}`}
              aria-disabled={item?.disabled === true}
              onMouseDown={(e) => handleMouseDown(item, e)}
            >
              {item?.prefix || item?.suffix ? (
                <span className="suggestions-name">{`${
                  item?.prefix ? item.prefix : ""
                } ${item?.name} ${item?.suffix ? item?.suffix : ""}`}</span>
              ) : item?.suggestionLabel ? (
                <Highlighter
                  className="suggestions-name"
                  searchWords={query ? [query] : []}
                  autoEscape={true}
                  textToHighlight={item.suggestionLabel}
                />
              ) : (
                <span
                  className="suggestions-name"
                  dangerouslySetInnerHTML={markIt(item?.name, query)}
                />
              )}
            </li>
          );
        })}
      </ul>
    </div>
  );
};

export default Suggestions;
